import React from 'react';

// Empty rather than "Invalid Date" when a note comes without its time.
export const fmtNoteDate = (iso) => {
  const date = iso ? new Date(iso) : null;
  if (!date || Number.isNaN(date.getTime())) return '';
  return date.toLocaleString('en-GB', {
    day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: '2-digit',
  });
};

// The server sends a link as `[label](url)`, or the bare address. Each is
// turned into an anchor here; everything else stays text.
const NOTE_LINK = /\[([^\]\n]+)\]\((https?:\/\/[^\s)]+)\)|(https?:\/\/[^\s]+)/g;

/**
 * A MOM note as plain text with its links made clickable. The server has
 * already stripped the markup, so nothing here is rendered as HTML.
 *
 * `linkIcon` is a component drawn after each link, since each app ships its
 * own icon set.
 */
const NoteText = ({ text, className, linkIcon: LinkIcon }) => {
  const parts = [];
  let last = 0;
  (text || '').replace(NOTE_LINK, (match, label, url, bare, offset) => {
    if (offset > last) parts.push(text.slice(last, offset));
    // A full stop or bracket closing the sentence is not part of a bare link,
    // so it stays in the text after it.
    const href = url || bare.replace(/[.,;:!?)\]]+$/, '');
    parts.push(React.createElement('a', {
      key: offset, href, target: '_blank', rel: 'noopener noreferrer',
    }, label || href, LinkIcon && React.createElement(LinkIcon)));
    last = offset + (url ? match.length : href.length);
    return match;
  });
  if (last < (text || '').length) parts.push(text.slice(last));
  return React.createElement('p', { className }, parts);
};

export default NoteText;
